import React from "react"

import { Input as DefaultInput, ErrorMessageProps } from "../../Input"
import { TextInputContext } from "../TextInputContext"

export const TextInputErrorMessage = React.memo(
  (props: ErrorMessageProps<Record<string, number>>) => {
    const { minLength, maxLength } = React.useContext(TextInputContext)

    return (
      <DefaultInput.ErrorMessage
        {...props}
        context={{ minLength, maxLength }}
      />
    )
  }
)
